module.exports = __webpack_public_path__ + "img/af55b25.png";